<template>
  <v-card class="elevation-0 px-0">
    <v-card-text class="px-0">
      <v-row class="mb-4 ta-center">
        <v-col>
          <div class="ta-center">
            <img src="../../assets/coffee.svg" class="mb-3" />
            <div class="c-dark-blue fs-26 fw-500 mx-auto mb-4 ta-center">Hold on to your coffee, <br>we’ve got some great daycares for you!</div>
            <v-progress-linear class="mx-auto mxw-775" height="6px" indeterminate=""></v-progress-linear>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {}
</script>
